import { defineStore } from 'pinia'
import type { FantasyGameId } from '~/types/fantasy'
import { useFantasySeasonStore } from './season'

export const useFantasyStore = defineStore('fantasy', {
  getters: {
    game(): FantasyGameId | undefined {
      const fantasySeasonStore = useFantasySeasonStore()
      return fantasySeasonStore.data?.game.id
    }
  }
})
